import client from '@/api/client.js';
import store from "@/store";
export default {
    methods: {
        async getLoggByJobId(jobId) {
            var meta = { clientApiMethod: 'getLoggByJobId', input: { jobId: jobId } }
            var response = await client().get(store.state.apiRouteRoot + "SupportLog/job/" + jobId, { meta: meta })
            return response?.data;
        },
        async createLogg(newlogg) {
            var meta = { clientApiMethod: 'createLogg', input: { newlogg } }
            var response = await client().post(store.state.apiRouteRoot + "SupportLog", newlogg, { meta: meta })
            return response?.data;
        },
        async changeLogg(logg) {
            var meta = { clientApiMethod: 'changeLogg', input: { logg } }
            var response = await client().patch(store.state.apiRouteRoot + "SupportLog", logg, { meta: meta })
            return response?.data;
        },


        async getJobLogsByJobId(jobId) {
            var meta = { clientApiMethod: 'getJobLogsByJobId', input: { jobId: jobId } }
            var response = await client().get(store.state.apiRouteRoot + "JobHistory/" + jobId, { meta: meta })
            return response?.data;
        },

        async getEventLogListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getEventLogListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Log/EventLogs/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getMailLogListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getMailLogListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Log/MailLogs/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getSmsLogListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getSmsLogListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Log/SMSLogs/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getCustomerLogListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getCustomerLogListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Log/CustomerLogs/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getMachineLogListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getMachineLogListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Log/MachineLogs/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getUnitLogListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getUnitLogListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Log/UnitLogs/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getArticleLogListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getArticleLogListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Log/ArticleLogs/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getAppointmentLogs() {
            var meta = { clientApiMethod: 'getAppointmentLogs' }
            var response = await client().get(store.state.apiRouteRoot + "Log/AppointmentLogs", { meta: meta })
            return response?.data;
        },
        async getTaskLogs() {
            var meta = { clientApiMethod: 'getTaskLogs' }
            var response = await client().get(store.state.apiRouteRoot + "Log/TaskLogs", { meta: meta })
            return response?.data;
        },
    }
}